import React, { useEffect, useState } from 'react';
import { fmtLocal, timeAgo } from '../utils/time';
import api, { asArray } from '../services/api';
import { useAuth } from '../context/AuthContext';
import SignalTabsNav from '../components/SignalTabsNav';
import { markNotificationsSeen } from '../utils/notificationAlerts';


export default function Notifications() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => api.get('/notifications')
      .then(res => setItems(asArray(res.data)))
      .catch(() => {})
      .finally(() => setLoading(false));
    load();
    // A push arrived while this tab is open — show it right away
    window.addEventListener('sx-notification-pushed', load);
    return () => window.removeEventListener('sx-notification-pushed', load);
  }, []);

  // Mark seen as soon as the tab is opened — matches the existing "seen once shown"
  // convention markSignalsSeen already uses for the Signals page.
  useEffect(() => {
    markNotificationsSeen(user);
  }, [user]);

  return (
    <div className="pb-8">
      <SignalTabsNav />
      <div className="mb-4">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Notifications</h1>
        <p className="text-xs text-slate-500 mt-1">Announcements and updates from StockXignal</p>
      </div>

      <div className="rounded-2xl border border-slate-700/60 bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 shadow-md overflow-hidden">
        <div className="p-2.5 space-y-1.5">
          {loading ? (
            <p className="text-center text-slate-500 text-xs py-8">Loading…</p>
          ) : items.length === 0 ? (
            <p className="text-center text-slate-500 text-xs py-8">No notifications yet.</p>
          ) : (
            items.map(n => (
              <div
                key={n.id}
                className="flex items-start gap-3 px-4 py-3 rounded-xl bg-white/[0.03] border border-white/5"
              >
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-emerald-400/15 text-emerald-300">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-white leading-snug">{n.message}</p>
                  <p className="text-[11px] text-slate-500 mt-1">{fmtLocal(n.createdAt)} · {timeAgo(n.createdAt)}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
